import mandatoryImage from "../../../../assets/images/orange-check-circle.png";
import nonMandatoryImage from "../../../../assets/images/xbox.png";
import recommended from "../../../../assets/images/blue-check-circle.png";
import thumb from "../../../../assets/images/like.png";

const ValidationChecks = ({ allFieldsSelected, handleSeeAllClick, mandatoryFieldsToShow, recommendedFieldsToShow }) => {
    return (
        <div className="frame-1000011459">
            <Section
                title="Mandatory"
                fields={mandatoryFieldsToShow}
                imageFn={field => (field.selected ? mandatoryImage : nonMandatoryImage)}
                showThumb={allFieldsSelected}
            />
            <Section
                title="Recommended"
                fields={recommendedFieldsToShow}
                imageFn={field => (field.selected ? recommended : nonMandatoryImage)}
            />
            <div className="checkbox-label" style={{ position: "absolute", right: "0px" }}>
                <div className="text" onClick={handleSeeAllClick}>
                    See All
                </div>
            </div>
        </div>
    );
};

// #region SMALL COMPONENTS
const Section = ({ title, imageFn, fields, showThumb }) => (
    <div className="frame-1000011396">
        <div className={title.toLowerCase()}>{title}:</div>
        <div className="frame-1000011397">
            {fields.map((field, index) => (
                <div className="checkbox-label" key={index}>
                    <img className="check-circle" src={imageFn(field)} alt="" />
                    <div className="gtin">{field.value}</div>
                </div>
            ))}
            {showThumb && fields?.length ? (
                <div className="checkbox-label">
                    <img className="thumbs-up" src={thumb} alt="" />
                    <div className="you-re-good-to-go">You’re good to go!</div>
                </div>
            ) : null}
        </div>
    </div>
);
// #endregion

export default ValidationChecks;
